import triggerAnalyticsEvent, { triggerEvent } from './analytics';

function getSlideDetail(slide) {
	let details;
	const $slide = $(slide);
	const values = [
		() => $slide.find('.CtaBlock-title').text().trim(),
		() => $slide.find('.CtaBlock-text').text().trim(),
		() => $slide.find('iframe').attr('src'),
		() => $slide.find('img').attr('alt'),
		() => {
			const imgSrc = $slide.find('img').attr('src');
			return imgSrc ? imgSrc.split('/').pop() : '';
		},
	];

	// Go through the functions until getting a truthy value
	while (!(details = values.shift()()) && values.length);
	return details;
}

function getCarouselProps(container, slide) {
	const name = `${container.prev('.Heading').find('.Heading-title').text() || 'Image'} Carousel`;
	const details = getSlideDetail(slide);

	return { name, details };
}

const transition = payload => {
	const { name, details } = getCarouselProps(payload.element, payload.slide);
	if (utag_data && utag_data.page_name && utag_data.page_name.indexOf(':residences') > -1) {
		triggerEvent('residences', 'image carousel click', details);
	} else {
		triggerEvent('image carousel', `${name} click`, details);
	}
};

const ctaClick = (payload, thisArg) => {
	const { name, details } = getCarouselProps(payload.element, payload.slide);
	if (utag_data && utag_data.page_name && utag_data.page_name.indexOf(':residences') > -1) {
		triggerEvent('residences', 'image carousel click', details, thisArg);
	} else {
		triggerEvent('image carousel', `${name} details click`, details, thisArg);
	}
};

export function attachAnalyticsEvents(payload) {
	const { container, slides } = payload;
	$(slides).each((_, slide) => {
		$(slide)
			.find('a.CTA')
			.on('click.analytics', function () {
				triggerAnalyticsEvent(
					'carousel.ctaClick',
					{
						element: container,
						slide,
					},
					$(this)
				);
			});
	});
}

export default {
	ctaClick,
	transition,
};
